module.exports = __webpack_public_path__ + "static/media/drug.d40468b9.jpg";